import {
  Box,
  Checkbox,
  FormControlLabel,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  CircularProgress,
} from '@mui/material';
import { useState } from 'react';
import styled from 'styled-components';
import { GridCloseIcon } from '@mui/x-data-grid';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';

import edit from '../../../assets/promotional-expense/edit.svg';
import viewEye from '../../../assets/promotional-expense/view-eye.svg';
import trash from '../../../assets/promotional-expense/trash.svg';
import document from '../../../assets/promotional-expense/document.svg';
import image from '../../../assets/promotional-expense/image.svg';

const Container = styled.div`
  border-radius: 10px;
  background: #ffffff;
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const InfoContainer = styled.div`
  width: 100%;
  text-align: start;
`;

const Block = styled.div`
  margin: 2px 0 0 0;
`;

const Span = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 17.71px;
`;

const OwnerName = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0%;
  color: #0088cc;
`;

const Date = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0%;
`;

const Amount = styled.span`
  font-weight: 700;
  font-size: 14px;
  color: #00b200;
`;

const Status = styled.span`
  display: 'block';
  border-radius: 10px;
  padding: 1px 5px 4px 5px;
  color: #fff;
  font-weight: 500;
`;

const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
`;

const ExpenseCard = ({
  expense,
  handleExpenseUpdate,
  handleExpenseDelete,
  handleCheck,
  handleVerify,
  selectedExpenses,
  type,
  user,
  auth,
}) => {
  console.log(auth);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialog2, setOpenDialog2] = useState(false);
  const [imageUrl, setImageUrl] = useState('');

  const [imageLoading, setImageLoading] = useState(true);

  const isChecked = selectedExpenses?.includes(expense.expensesfid);

  const handleDocument = (url, type) => {
    setOpenDialog(true);
    if (type === 'document') {
      getBase64FromS3(url);
    } else {
      setImageUrl(url);
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const getBase64FromS3 = async (url) => {
    try {
      const response = await axios.get(url, { responseType: 'arraybuffer' });
      const arrayBuffer = response.data;

      const base64 = btoa(
        new Uint8Array(arrayBuffer).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ''
        )
      );

      const base64String = `data:application/pdf;base64,${base64}`;
      setImageUrl(base64String);
      return base64String;
    } catch (error) {
      console.error('Error fetching image from S3:', error);
    }
  };

  const getFormattedDate = (date) => {
    const months = {
      '01': 'Jan',
      '02': 'Feb',
      '03': 'Mar',
      '04': 'Apr',
      '05': 'May',
      '06': 'Jun',
      '07': 'Jul',
      '08': 'Aug',
      '09': 'Sep',
      10: 'Oct',
      11: 'Nov',
      12: 'Dec',
    };

    const splittedDate = date.split('-');
    const monthName = months[splittedDate[1]];

    return `${splittedDate[2]}-${monthName}-${splittedDate[0]}`;
  };

  const renderContent = () => {
    return (
      <Container style={{ display: expense ? 'block' : 'none' }}>
        {type === 'draft' && (
          <FlexContainer style={{ margin: '5px 10px 0 10px' }}>
            <Date>{getFormattedDate(expense?.date__c)}</Date>
            <Box>
              <FormControlLabel
                sx={{ margin: 0 }}
                control={
                  <Checkbox
                    onClick={(e) => handleCheck(e, expense)}
                    checked={isChecked}
                  />
                }
              />
            </Box>
          </FlexContainer>
        )}

        {type === 'claim' && (
          <FlexContainer style={{ margin: '10px 10px 5px 10px' }}>
            <Box>
              <Date>{getFormattedDate(expense?.date__c)}</Date>
              <Status
                style={{
                  backgroundColor:
                    expense.expense_final_status__c === 'approved'
                      ? '#00B200'
                      : expense.expense_final_status__c === 'pending'
                      ? '#E57300'
                      : '#FF3333',
                  marginLeft: 15,
                }}
              >
                {expense.expense_final_status__c === 'approved' && 'Approved'}
                {expense.expense_final_status__c === 'pending' && 'Pending'}
                {expense.expense_final_status__c === 'rejected' && 'Rejected'}
              </Status>
            </Box>
          </FlexContainer>
        )}

        {type === 'approval' && (
          <FlexContainer style={{ margin: '5px 10px 0 10px' }}>
            <Box>
              <Date>{getFormattedDate(expense?.date__c)}</Date>
              <Status
                style={{
                  backgroundColor:
                    expense.expense_final_status__c === 'approved'
                      ? '#00B200'
                      : expense.expense_final_status__c === 'pending'
                      ? '#E57300'
                      : '#FF3333',
                  marginLeft: 15,
                }}
              >
                {expense.expense_final_status__c === 'approved' && 'Approved'}
                {expense.expense_final_status__c === 'pending' && 'Pending'}
                {expense.expense_final_status__c === 'rejected' && 'Rejected'}
              </Status>
            </Box>

            <Box>
              <FormControlLabel
                sx={{
                  margin: 0,
                  visibility:
                    user?.profile__c === 'Finance' ? 'hidden' : 'visible',
                }}
                control={
                  <Checkbox
                    onClick={(e) => handleCheck(e, expense)}
                    checked={isChecked}
                    // disabled={user?.profile__c === 'Finance'}
                  />
                }
              />
            </Box>
          </FlexContainer>
        )}

        {type === 'history' && (
          <FlexContainer style={{ margin: '5px 10px 0 10px' }}>
            <Box>
              <Date>{getFormattedDate(expense?.date__c)}</Date>
              <Status
                style={{
                  backgroundColor:
                    expense.expense_final_status__c === 'approved'
                      ? '#00B200'
                      : expense.expense_final_status__c === 'pending'
                      ? '#E57300'
                      : '#FF3333',
                  marginLeft: 15,
                }}
              >
                {expense.expense_final_status__c === 'approved' && 'Approved'}
                {expense.expense_final_status__c === 'pending' && 'Pending'}
                {expense.expense_final_status__c === 'rejected' && 'Rejected'}
              </Status>
            </Box>

            <Box>
              <FormControlLabel
                sx={{
                  margin: 0,
                  visibility: 'hidden',
                }}
                control={
                  <Checkbox
                    onClick={(e) => handleCheck(e, expense)}
                    checked={isChecked}
                    // disabled={user?.profile__c === 'Finance'}
                  />
                }
              />
            </Box>
          </FlexContainer>
        )}

        <FlexContainer style={{ margin: '0 10px 2px 10px' }}>
          <InfoContainer>
            <Block>
              <Span>{expense?.formated_event_name__c}</Span>
            </Block>
            <Block>
              <Span>Event Owner: </Span>
              {expense?.event_owner_name ? (
                <OwnerName>
                  {expense?.event_owner_name}-{expense?.territoryname}
                </OwnerName>
              ) : (
                <OwnerName>N/A</OwnerName>
              )}
            </Block>
            {type === 'approval' && (
              <Block>
                <Span>Expense Owner: </Span>
                <OwnerName>
                  {expense?.expense_owner_name
                    ? expense?.expense_owner_name
                    : 'N/A'}
                </OwnerName>
              </Block>
            )}
            {type === 'history' && (
              <Block>
                <Span>Expense Owner: </Span>
                <OwnerName>
                  {expense?.expense_owner_name
                    ? expense?.expense_owner_name
                    : 'N/A'}
                </OwnerName>
              </Block>
            )}
            {type === 'approval' && (
              <Block>
                <Span>View Document: </Span>
                <OwnerName>
                  <VisibilityIcon
                    sx={{
                      backgroundColor: '#FFF',
                      color:
                        !expense?.upload_file__c ||
                        expense?.upload_file__c === 'undefined' ||
                        expense?.upload_file__c === 'null'
                          ? 'grey.400'
                          : 'primary.main',
                      pointerEvents:
                        !expense?.upload_file__c ||
                        expense?.upload_file__c === 'undefined' ||
                        expense?.upload_file__c === 'null'
                          ? 'none'
                          : 'auto',
                      '&:hover': {
                        cursor:
                          !expense?.upload_file__c ||
                          expense?.upload_file__c === 'undefined' ||
                          expense?.upload_file__c === 'null'
                            ? 'default'
                            : 'pointer',
                      },
                    }}
                    onClick={() => {
                      if (
                        expense?.upload_file__c &&
                        expense?.upload_file__c !== 'undefined' &&
                        expense?.upload_file__c !== 'null'
                      ) {
                        setOpenDialog2(true);
                      } else {
                        window.NotificationUtils?.showError?.(
                          'Image not available'
                        );
                      }
                    }}
                  />

                  <Dialog
                    open={openDialog2}
                    onClose={() => setOpenDialog2(false)}
                    maxWidth='md'
                    fullWidth
                  >
                    <DialogTitle>
                      Preview
                      <IconButton
                        aria-label='close'
                        onClick={() => setOpenDialog2(false)}
                        sx={{
                          position: 'absolute',
                          right: 8,
                          top: 8,
                          color: (theme) => theme.palette.grey[500],
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                      {expense?.upload_file__c
                        ?.toLowerCase()
                        .endsWith('.pdf') ? (
                        <iframe
                          src={expense?.upload_file__c}
                          title='PDF Preview'
                          style={{
                            width: '100%',
                            height: '80vh',
                            border: 'none',
                          }}
                        />
                      ) : (
                        <>
                          {imageLoading && (
                            <div
                              style={{ textAlign: 'center', padding: '20px' }}
                            >
                              <CircularProgress />
                            </div>
                          )}

                          <img
                            src={expense?.upload_file__c}
                            alt='Preview'
                            onLoad={() => setImageLoading(false)}
                            style={{
                              maxWidth: '100%',
                              maxHeight: '80vh',
                              display: 'block',
                              margin: '0 auto',
                            }}
                          />
                        </>
                      )}
                    </DialogContent>
                  </Dialog>
                </OwnerName>
              </Block>
            )}
            {type === 'history' && (
              <Block>
                <Span>View Document: </Span>
                <OwnerName>
                  <VisibilityIcon
                    sx={{
                      backgroundColor: '#FFF',
                      color:
                        !expense?.upload_file__c ||
                        expense?.upload_file__c === 'undefined' ||
                        expense?.upload_file__c === 'null'
                          ? 'grey.400'
                          : 'primary.main',
                      pointerEvents:
                        !expense?.upload_file__c ||
                        expense?.upload_file__c === 'undefined' ||
                        expense?.upload_file__c === 'null'
                          ? 'none'
                          : 'auto',
                      '&:hover': {
                        cursor:
                          !expense?.upload_file__c ||
                          expense?.upload_file__c === 'undefined' ||
                          expense?.upload_file__c === 'null'
                            ? 'default'
                            : 'pointer',
                      },
                    }}
                    onClick={() => {
                      if (
                        expense?.upload_file__c &&
                        expense?.upload_file__c !== 'undefined' &&
                        expense?.upload_file__c !== 'null'
                      ) {
                        setOpenDialog2(true);
                      } else {
                        window.NotificationUtils?.showError?.(
                          'Image not available'
                        );
                      }
                    }}
                  />

                  <Dialog
                    open={openDialog2}
                    onClose={() => setOpenDialog2(false)}
                    maxWidth='md'
                    fullWidth
                  >
                    <DialogTitle>
                      Preview
                      <IconButton
                        aria-label='close'
                        onClick={() => setOpenDialog2(false)}
                        sx={{
                          position: 'absolute',
                          right: 8,
                          top: 8,
                          color: (theme) => theme.palette.grey[500],
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                      {expense?.upload_file__c
                        ?.toLowerCase()
                        .endsWith('.pdf') ? (
                        <iframe
                          src={expense?.upload_file__c}
                          title='PDF Preview'
                          style={{
                            width: '100%',
                            height: '80vh',
                            border: 'none',
                          }}
                        />
                      ) : (
                        <>
                          {imageLoading && (
                            <div
                              style={{ textAlign: 'center', padding: '20px' }}
                            >
                              <CircularProgress />
                            </div>
                          )}

                          <img
                            src={expense?.upload_file__c}
                            alt='Preview'
                            onLoad={() => setImageLoading(false)}
                            style={{
                              maxWidth: '100%',
                              maxHeight: '80vh',
                              display: 'block',
                              margin: '0 auto',
                            }}
                          />
                        </>
                      )}
                    </DialogContent>
                  </Dialog>
                </OwnerName>
              </Block>
            )}
            {type === 'claim' && (
              <Block>
                <Span>Status: </Span>
                <OwnerName>{expense?.next_approval_status__c}</OwnerName>
              </Block>
            )}

            <Block>
              <Span>Claimed: </Span>
              <OwnerName>
                <Amount>&#8377;{expense?.amount__c}</Amount>
              </OwnerName>
            </Block>

            {expense?.approved_amount__c > 0 && (
              <Block>
                <Span>Current Approved: </Span>
                <OwnerName>
                  <Amount>&#8377;{expense?.approved_amount__c}</Amount>
                </OwnerName>
              </Block>
            )}

            {expense?.profile__c === 'SI' &&
              expense?.rm_approved_amount__c > 0 && (
                <Block>
                  <Span>RM Approved: </Span>
                  <OwnerName>
                    <Amount>&#8377;{expense?.rm_approved_amount__c}</Amount>
                  </OwnerName>
                </Block>
              )}

            {expense?.profile__c === 'AM' &&
              expense?.rm_approved_amount__c > 0 && (
                <Block>
                  <Span>RM Approved: </Span>
                  <OwnerName>
                    <Amount>&#8377;{expense?.rm_approved_amount__c}</Amount>
                  </OwnerName>
                </Block>
              )}

            {expense?.profile__c === 'SI' &&
              expense?.rmm_approved_amount__c > 0 && (
                <Block>
                  <Span>RMM Approved: </Span>
                  <OwnerName>
                    <Amount>&#8377;{expense?.rmm_approved_amount__c}</Amount>
                  </OwnerName>
                </Block>
              )}

            {expense?.profile__c === 'AM' &&
              expense?.rmm_approved_amount__c > 0 && (
                <Block>
                  <Span>RMM Approved: </Span>
                  <OwnerName>
                    <Amount>&#8377;{expense?.rmm_approved_amount__c}</Amount>
                  </OwnerName>
                </Block>
              )}

            {expense?.profile__c === 'SI' &&
              expense?.zm_approved_amount__c > 0 && (
                <Block>
                  <Span>ZM Approved: </Span>
                  <OwnerName>
                    <Amount>&#8377;{expense?.zm_approved_amount__c}</Amount>
                  </OwnerName>
                </Block>
              )}

            {expense?.profile__c === 'AM' &&
              expense?.zm_approved_amount__c > 0 && (
                <Block>
                  <Span>ZM Approved: </Span>
                  <OwnerName>
                    <Amount>&#8377;{expense?.zm_approved_amount__c}</Amount>
                  </OwnerName>
                </Block>
              )}

            {expense?.profile__c === 'RM' &&
              expense?.zm_approved_amount__c > 0 && (
                <Block>
                  <Span>ZM Approved: </Span>
                  <OwnerName>
                    <Amount>&#8377;{expense?.zm_approved_amount__c}</Amount>
                  </OwnerName>
                </Block>
              )}

            {expense?.profile__c === 'RM' &&
              expense?.vp_approved_amount__c > 0 && (
                <Block>
                  <Span>VP Approved: </Span>
                  <OwnerName>
                    <Amount>&#8377;{expense?.vp_approved_amount__c}</Amount>
                  </OwnerName>
                </Block>
              )}

            {expense?.profile__c === 'RM' &&
              expense?.sfdc_level1_approved_amount__c > 0 && (
                <Block>
                  <Span>SFDC Level 1 Approved: </Span>
                  <OwnerName>
                    <Amount>
                      &#8377;{expense?.sfdc_level1_approved_amount__c}
                    </Amount>
                  </OwnerName>
                </Block>
              )}

            {expense?.profile__c === 'RMM' &&
              expense?.sfdc_level1_approved_amount__c > 0 && (
                <Block>
                  <Span>SFDC Level 1 Approved (Amit Joshi): </Span>
                  <OwnerName>
                    <Amount>
                      &#8377;{expense?.sfdc_level1_approved_amount__c}
                    </Amount>
                  </OwnerName>
                </Block>
              )}

            {expense?.profile__c === 'ZM' &&
              expense?.sfdc_level2_approved_amount__c > 0 && (
                <Block>
                  <Span>SFDC Level 2 Approved (Sood Sir): </Span>
                  <OwnerName>
                    <Amount>
                      &#8377;{expense?.sfdc_level2_approved_amount__c}
                    </Amount>
                  </OwnerName>
                </Block>
              )}
          </InfoContainer>
        </FlexContainer>

        {/* <FlexContainer style={{ margin: '5px 10px 10px 10px' }}>
          <Box style={{ visibility: 'hidden' }}>
            <Span>Claimed:</Span> <Amount>₹{expense?.amount__c}</Amount>{' '}
            {expense?.approved_amount__c > 0 && (
              <span>
                | <Span>Approved:</Span>{' '}
                <Amount>₹{expense?.approved_amount__c}</Amount>
              </span>
            )}
          </Box>
          <Box>
            {type === 'draft' && (
              <Box
                sx={{
                  '&:hover': {
                    cursor: 'pointer',
                  },
                }}
              >
                <img src={edit} onClick={() => handleExpenseUpdate(expense)} />
                <img src={trash} onClick={() => handleExpenseDelete(expense)} />
              </Box>
            )}

            {type === 'approval' && (
              <Box
                sx={{
                  visibility:
                    user?.profile__c === 'Finance' ? 'hidden' : 'visible',
                  '&:hover': {
                    cursor:
                      user?.profile__c === 'Finance'
                        ? 'not-allowed'
                        : 'pointer',
                  },
                }}
              >
                <img src={edit} onClick={() => handleExpenseUpdate(expense)} />
              </Box>
            )}

            {type === 'history' && (
              <Box
                sx={{
                  visibility:
                    user?.profile__c === 'Finance' ? 'hidden' : 'visible',
                  '&:hover': {
                    cursor:
                      user?.profile__c === 'Finance'
                        ? 'not-allowed'
                        : 'pointer',
                  },
                }}
              >
                <img
                  src={viewEye}
                  onClick={() => handleExpenseUpdate(expense)}
                />
              </Box>
            )}

            {type === 'claim' && (
              <Box
                sx={{
                  '&:hover': {
                    cursor: 'pointer',
                  },
                }}
              >
                {expense.upload_file__c &&
                  expense.upload_file__c?.includes('.pdf') && (
                    <img
                      src={document}
                      onClick={() =>
                        handleDocument(expense.upload_file__c, 'document')
                      }
                    />
                  )}
                {expense.upload_file__c &&
                  !expense.upload_file__c?.includes('.pdf') && (
                    <img
                      src={image}
                      onClick={() =>
                        handleDocument(expense.upload_file__c, 'image')
                      }
                    />
                  )}
              </Box>
            )}
          </Box>
        </FlexContainer> */}
      </Container>
    );
  };

  return (
    <>
      <Container
        style={{
          boxShadow: '0px 4px 10px 0px #0000001A',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        {renderContent()}
        <FlexContainer style={{ margin: '5px 10px 10px 10px' }}>
          <Box style={{ visibility: 'hidden' }}>
            <Span>Claimed:</Span> <Amount>₹{expense?.amount__c}</Amount>{' '}
            {expense?.approved_amount__c > 0 && (
              <span>
                | <Span>Approved:</Span>{' '}
                <Amount>₹{expense?.approved_amount__c}</Amount>
              </span>
            )}
          </Box>
          <Box>
            {type === 'draft' && (
              <Box
                sx={{
                  '&:hover': {
                    cursor: 'pointer',
                  },
                }}
              >
                <img src={edit} onClick={() => handleExpenseUpdate(expense)} />
                <img src={trash} onClick={() => handleExpenseDelete(expense)} />
              </Box>
            )}

            {type === 'approval' && (
              <Box
                sx={{
                  visibility:
                    user?.profile__c === 'Finance' ? 'hidden' : 'visible',
                  '&:hover': {
                    cursor:
                      user?.profile__c === 'Finance'
                        ? 'not-allowed'
                        : 'pointer',
                  },
                }}
              >
                <FlexContainer style={{ justifyContent: 'flex-end' }}>
                  {expense?.verified__c && (
                    <div
                      style={{
                        backgroundColor: '#4CAF50',
                        color: '#fff',
                        padding: '3px 6px',
                        margin: '0 10px 0 0',
                        borderRadius: '15px',
                        fontWeight: '500',
                      }}
                    >
                      Verified
                    </div>
                  )}
                  <img
                    src={edit}
                    onClick={() => handleExpenseUpdate(expense)}
                  />
                </FlexContainer>
              </Box>
            )}

            {type === 'approval' && (
              <Box
                sx={{
                  visibility:
                    user?.profile__c === 'Finance' ? 'visible' : 'hidden',
                  '&:hover': {
                    cursor:
                      user?.profile__c === 'Finance'
                        ? 'not-allowed'
                        : 'pointer',
                  },
                }}
              >
                <FlexContainer style={{ justifyContent: 'flex-end' }}>
                  {auth?.profile__c === 'Finance' &&
                    (expense?.verified__c ? (
                      <div
                        style={{
                          backgroundColor: '#4CAF50',
                          color: '#fff',
                          padding: '3px 6px',
                          borderRadius: '10px',
                          fontWeight: '500',
                        }}
                      >
                        Verified
                      </div>
                    ) : (
                      <button
                        style={{
                          padding: '6px 12px',
                          borderRadius: '6px',
                          border: 'none',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleVerify(expense)}
                      >
                        Verify
                      </button>
                    ))}
                </FlexContainer>
              </Box>
            )}

            {type === 'history' && (
              <Box
                sx={{
                  visibility:
                    user?.profile__c === 'Finance' ? 'hidden' : 'visible',
                  '&:hover': {
                    cursor:
                      user?.profile__c === 'Finance'
                        ? 'not-allowed'
                        : 'pointer',
                  },
                }}
              >
                <FlexContainer style={{ justifyContent: 'flex-end' }}>
                  {expense?.verified__c && (
                    <div
                      style={{
                        backgroundColor: '#4CAF50',
                        color: '#fff',
                        padding: '3px 6px',
                        margin: '0 10px 0 0',
                        borderRadius: '10px',
                        fontWeight: '500',
                      }}
                    >
                      Verified
                    </div>
                  )}
                  <img
                    src={viewEye}
                    onClick={() => handleExpenseUpdate(expense)}
                  />
                </FlexContainer>
              </Box>
            )}

            {/* {type === 'history' && (
              <Box
                sx={{
                  visibility:
                    user?.profile__c === 'Finance' ? 'visible' : 'hidden',
                  '&:hover': {
                    cursor:
                      user?.profile__c === 'Finance'
                        ? 'not-allowed'
                        : 'pointer',
                  },
                }}
              >
                <FlexContainer style={{ justifyContent: 'flex-end' }}>
                  {expense?.verified__c && (
                    <div
                      style={{
                        backgroundColor: '#4CAF50',
                        color: '#fff',
                        padding: '3px 6px',
                        borderRadius: '10px',
                        fontWeight: '500',
                      }}
                    >
                      Verified
                    </div>
                  )}
                </FlexContainer>
              </Box>
            )} */}

            {type === 'claim' && (
              <Box
                sx={{
                  '&:hover': {
                    cursor: 'pointer',
                  },
                }}
              >
                {expense.upload_file__c &&
                  expense.upload_file__c?.includes('.pdf') && (
                    <img
                      src={document}
                      onClick={() =>
                        handleDocument(expense.upload_file__c, 'document')
                      }
                    />
                  )}
                {expense.upload_file__c &&
                  !expense.upload_file__c?.includes('.pdf') && (
                    <img
                      src={image}
                      onClick={() =>
                        handleDocument(expense.upload_file__c, 'image')
                      }
                    />
                  )}
              </Box>
            )}
          </Box>
        </FlexContainer>
        <Dialog
          open={openDialog}
          onClose={handleClose}
          sx={{
            '& .MuiPaper-root.MuiDialog-paper': {
              borderRadius: '16px',
              padding: '24px',
              boxShadow:
                'rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px',
              width: '600px',
            },
            '& .MuiBackdrop-root': {
              backgroundColor: 'transparent',
              backdropFilter: 'blur(1px)',
            },
          }}
        >
          <DialogTitle>
            <IconButton
              onClick={handleClose}
              style={{ position: 'absolute', top: 8, right: 8 }}
            >
              <GridCloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent style={{ paddingTop: '5px' }}>
            <DialogContainer>
              {expense.upload_file__c?.includes('.pdf') ? (
                <iframe
                  src={imageUrl}
                  title='PDF Preview'
                  width='100%'
                  height='1015px'
                  style={{ border: 'none' }}
                />
              ) : (
                <img
                  src={imageUrl}
                  alt='Selected Image'
                  style={{
                    borderRadius: 8,
                    objectFit: 'cover',
                    margin: '3px',
                    width: '100%',
                    height: 'auto',
                  }}
                />
              )}
            </DialogContainer>
          </DialogContent>
        </Dialog>
      </Container>
    </>
  );
};

export default ExpenseCard;
